import {z} from '@hono/zod-openapi';

const MAX_SDP_OFFER_LENGTH = 64 * 1024;

export const VoiceDebugWebRtcOfferRequestSchema = z
  .object({
    schemaVersion: z.literal('1.0.0'),
    sdpOffer: z
      .string()
      .min(1)
      .max(MAX_SDP_OFFER_LENGTH)
      .refine((value) => new TextEncoder().encode(value).byteLength <= MAX_SDP_OFFER_LENGTH),
    idempotencyKey: z.string().min(1).max(128).regex(/\S/),
  })
  .strict()
  .openapi('VoiceDebugWebRtcOfferRequestSchema');

export type VoiceDebugWebRtcOfferRequest = z.infer<typeof VoiceDebugWebRtcOfferRequestSchema>;
